export default {
	baseURL: process.env.VUE_APP_BACKEND_HOST,
	apartmentType: process.env.VUE_APP_APARTMENT_TYPE,
	debug: false,
	analytics: {
		gtmId: process.env.VUE_APP_GTM_ID,
	}
}
